import { Component, OnInit } from '@angular/core';
import { Guid } from 'guid-typescript';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TimeService } from 'src/app/services/time/time.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-emergency-shutdown',
  templateUrl: './emergency-shutdown.component.html',
  styleUrls: ['./emergency-shutdown.component.css']
})
export class EmergencyShutdownComponent implements OnInit {

  dayInMS = 86400000;
  formMessage = "";
  formError = false;
  
  lobSelected: string = "All LOBs";
  groupSelected: any = "All Groups";
  queueSelected: any = "All Queues";
  languageSelected: string = "en-US";
  startDate;
  startTime;
  endDate;
  endTime;
  noEndTime: boolean = false;
  formValid = false;
  shutdownConfirmation: string = "";
  message;


  idMap = new Map<string, any>();

  messageData = [];
  queueData = { "queues": []};

  maxStartDate;
  minStartDate;
  maxEndDate;
  minEndDate;
  mouseIndex = -1;

  lobs = [];
  groups = [];
  filteredGroups = [];
  queues = [];
  filteredQueues = [];
  languages = [];
  shutdownMessages = [["en-US", ""]];

  progress:number = 0;
  currentUser: any;
  isTelecom:boolean;
  constructor(private telecomService:TelecomService, private config:ConfigService, private auth: AuthService, private time: TimeService) { }

  ngOnInit(): void {
    //fix and put in its own function
    let today = new Date();
    let tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1)

    this.startDate = this.formatDate(today);
    this.startTime = this.formatTime(today);

    this.endDate = this.formatDate(tomorrow);
    this.endTime = this.startTime;
    this.minEndDate = this.startDate;
    this.telecomService.getLanguages().then((resultData:any)=>{
      console.log("get language result: ", resultData);
      this.languages = resultData.languages;
    });
    this.getQueues()
    this.getLOBs()
    this.getGroups()
    this.currentUser = this.auth.userPool.getCurrentUser().username;
    this.currentUser = this.currentUser.split("_")[1];
    console.log(this.currentUser);
    this.isTelecom = this.auth.memberOf.includes(environment.roles.telecom);
    if(!this.isTelecom && this.config.activeConfig!=null){
      this.lobSelected = this.config.activeLOB;
    }
  }

  validate(){
    this.formMessage = '';
    this.formError = false;

    if(!this.startDate){
      this.formMessage = "Start date is required."
      this.formError = true;
      return false;
    }
    this.minEndDate = this.startDate;
    if(!this.startTime){
      this.formMessage = "Start time is required."
      this.formError = true;
      return false;
    }
    if(!this.endDate){
      this.formMessage = "End date is required."
      this.formError = true;
      return false;
    }   
    if(!this.endTime){
      this.formMessage = "End time is required."
      this.formError = true;
      return false;
    }
    //sets end date to after start date, if it isn't already
    let startTimestamp = new Date(this.startDate + ", " + this.startTime);
    let endTimestamp = new Date(this.endDate + ", " + this.endTime);
    while(startTimestamp.getTime() >= endTimestamp.getTime()){
      let timeDiff = startTimestamp.getTime() - endTimestamp.getTime();
      //skip days while the difference is big
      if(timeDiff >= this.dayInMS){
        endTimestamp.setDate(endTimestamp.getDate()+1);
      }else{
        endTimestamp.setMinutes(endTimestamp.getMinutes()+1);
      }
      this.endDate = this.formatDate(endTimestamp);
      this.endTime = this.formatTime(endTimestamp);
      this.minEndDate = this.startDate;
    }

    for(let i=0;i<this.shutdownMessages.length;i++){
      if(!this.shutdownMessages[i][0]){
        this.formMessage = "Language is required on each message."
        this.formError = true;
        return false;
      }
      if(!this.shutdownMessages[i][1]){
        console.log(this.shutdownMessages[i][1]);
        this.formMessage = "Message text is required on each message."
        this.formError = true;
        return false;
      }
    }

    return true; 
  }

  filterQueues(){
    console.log(this.lobSelected)
    console.log(this.groupSelected)
    console.log(this.queueSelected)
    this.filteredGroups = [];
    this.filteredQueues = [];
      for(let i=0;i<this.groups.length;i++){
        if(this.groups[i].LOB == this.lobSelected || this.lobSelected == "All LOBs"){
          console.log(this.groups[i])
          this.filteredGroups.push(this.groups[i]);
        }
      }
      if(this.filteredGroups.length == 0){
        this.groupSelected = "All Groups";
      }
      for(let i=0;i<this.queues.length;i++){
        if((this.queues[i].LOB == this.lobSelected || this.lobSelected == "All LOBs")
         && (this.queues[i].groupId == this.groupSelected.groupId || this.groupSelected == "All Groups")
         && (this.queues[i].queueName == this.queueSelected.queueName || this.queueSelected == "All Queues")){
          console.log(this.queues[i])
          this.filteredQueues.push(this.queues[i]);
        }
      }
      if(this.filteredQueues.length == 0){
        this.queueSelected = "All Queues";
      }
  }
  
  setEndTime(){
    this.endDate = "9999-12-31";
    this.endTime = "00:00";
  }

  addMessage(){
    let lastMessage = this.shutdownMessages.length-1;
    if(this.shutdownMessages.length == 0 ||
       (this.shutdownMessages[lastMessage][1] && this.shutdownMessages[lastMessage][0])){
      this.shutdownMessages.push(["",""]);
    }

  }

  deleteMessage(index){
    this.shutdownMessages.splice(index,1);
  }

  resetShutdown(){
    this.lobSelected = "All LOBs";
    this.groupSelected = "All Groups";
    this.queueSelected = "All Queues";
    this.languageSelected = "en-US";
    this.shutdownMessages = [["en-US", ""]];
    this.progress = 0;
    this.formValid = false;
  }

  updateItem(item){

  }

  isFiltered(language, message){
    for(let j=0;j<this.shutdownMessages.length;j++){
      if(language[1] == this.shutdownMessages[j][0] && message != this.shutdownMessages[j]){
        return true;
      }
    }
    return false;
  }

  formatData(){
    this.progress = 2;
    this.messageData = [];
    this.queueData.queues = [];
    for(let i=0;i<this.shutdownMessages.length;i++){
      let guid = this.getGUID();
      let lang = this.shutdownMessages[i][0];
      let text = this.shutdownMessages[i][1];
      let message ={
        "message":{
          "messageTitle": "Emergency Closure",
          "messageType": "Closure",
          "msgText": { 
          },
          "status": "Enabled",
        },
        "messageId": guid,
        "updatedBy": this.currentUser,
        "lastUpdated": this.time.wireFormatDate(new Date(),0),
        "messageDuration": {
          "messageEndDate": this.endDate,
          "messageEndTime": this.endTime,
          "messageStartDate": this.startDate,
          "messageStartTime": this.startTime
        }
      }
      message.message.msgText[lang] = text;
      
      this.messageData.push(message);
    }
    for(let i=0;i<this.filteredQueues.length;i++){
      let queue = {  
        "messageDuration": {
          "messageEndDate": this.endDate,
          "messageEndTime": this.endTime,
          "messageStartDate": this.startDate,
          "messageStartTime": this.startTime
        },
      "messageId": "",
      "queueId": this.filteredQueues[i].queueId,
      "updatedBy": this.currentUser,
      "lastUpdated": this.time.wireFormatDate(new Date(),0)
      }
      for(let j=0;j<this.shutdownMessages.length;j++){
        console.log("lang msg: ", this.shutdownMessages[j][0])
        console.log("lang q: ", this.filteredQueues[i].language)
        console.log("Queue: ", this.filteredQueues[i])
        let defaultToEnglish = (!queue.messageId && this.shutdownMessages[j][0] == "en-US")
        if(this.filteredQueues[i].language == this.shutdownMessages[j][0] || defaultToEnglish){
          console.log("Queue: ", this.filteredQueues[i])
          console.log("MessageID", this.messageData[j].messageId);
          queue.messageId = this.messageData[j].messageId;
          
        }
      }
      console.log(queue)
      this.queueData.queues.push(queue);
    }
    this.buildIdMap();
  }

  confirmed(){
    if(this.shutdownConfirmation.toLowerCase() == "shutdown"){
      return true;
    }
    return false;
  }

  formatDate(date){
    date.setDate(date.getDate())
    var year: any = date.getFullYear();
    var month: any = date.getMonth()+1;
    var dt: any = date.getDate();
    if (dt < 10) {
      dt = '0' + dt;
    }
    if (month < 10) {
      month = '0' + month;
    }
    return year + '-' + month + '-' + dt;
  }

  formatTime(time){
    let hour = time.getHours();
    let minute = time.getMinutes();
    if (hour < 10) {
      hour = '0' + hour;
    }
    if (minute < 10) {
      minute = '0' + minute;
    }
    return  "" + hour + ":" + minute;
  }

  buildIdMap(){
    this.idMap = new Map<string, any>();

    //if there is no group set
    this.idMap.set(undefined, {groupName:""});
    this.idMap.set(null, {groupName:""});
    this.idMap.set("", {groupName:""});

    for(let i=0;i<this.queues.length;i++){
      this.idMap.set(this.queues[i].queueId, this.queues[i]);
    }
    for(let i=0;i<this.shutdownMessages.length;i++){
      
      console.log(this.messageData[i].messageId);
      this.idMap.set(this.messageData[i].messageId, this.messageData[i]);
    }
    for(let i=0;i<this.groups.length;i++){
      this.idMap.set(this.groups[i].groupId, this.groups[i])
    }
    console.log(this.idMap);
  }

  getGUID(){
    return Guid.create()['value'];
  }

  getQueues(){
    this.telecomService.getRows(environment.QueuesLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.queues = data.body.queueList;
      }
      else{
        console.error(data.Error)
      }
      this.filterQueues();
    });
  }

  getLOBs(){
    this.lobs = this.telecomService.lobList;
    this.telecomService.getLOBs().then((resultData:any)=>{
      console.log("get lob result: ", resultData);
      this.lobs = resultData.lobList;
      this.filterQueues();
    });
  }

  getGroups(){
    this.telecomService.getRows(environment.GroupsLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.groups = data.body.Group.Item.data;
      }
      else{
        console.error(data.Error)
      }
      this.filterQueues();
    });
  }

  shutdownQueues(){
    this.progress = 3;
    for(let i=0;i<this.queueData.queues.length;i++){
      let rows = {item:this.queueData.queues[i], action:"put"};
      console.log("queueMessage", i, ": ", rows);
    this.telecomService.saveRow(rows, environment.QueueMessagesLambdaName).then((data: any) => {
      if(data.statusCode == 200){
        this.message = "Emergency shutdown initiated successfully @ " + this.time.wireFormatDate(new Date(),0) + " by " + this.currentUser;
      }
      else{
        this.message = data.Error.message;
        console.log(data.Error);
      }
    });
    }
    for(let i=0;i<this.messageData.length;i++){
      let message = this.messageData[i];
      let row = {item: message, action:"put"};
      console.log("Message", i, ": ", row);
      this.telecomService.saveRow(row, environment.messagesLambdaName).then((data: any) => {
        if(data.statusCode == 200){
          this.message = "Emergency shutdown initiated successfully @ " + this.time.wireFormatDate(new Date(),0) + " by " + this.currentUser;
        }
        else{
          this.message = data.Error.message;
          console.log(data.Error);
        }
      });
    }
  }

  getClosureRoute(){
    let route = '/closures'
    if(this.config.activeLOB){
      route = '/' + this.config.activeLOB + route;
    }
    return route
  }
}
